import { RESET_ACTIVITY_COUNTER } from '../types';

export const resetActivityCounter = () => dispatch => {
  dispatch({
    type: RESET_ACTIVITY_COUNTER
  });
};
